import EfImg from '@elem/ui/ef-img';
import { useEffect } from 'react';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useMediaDevice } from '../../hooks';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';
import gtm from '@/utils/gtm';

export default function TheComp() {
    const { t } = useLang('Oasis.ListA');
    const { locale = 'eu' } = useRouter();
    const imgItems: {
        [key: string]: any;
    } = {
        eu: {
            page: [
                'https://websiteoss.ecoflow.com/upload/image/1744876856864/Frame%201612689842.png',
                'https://websiteoss.ecoflow.com/upload/image/1744458336412/Frame%201612690123.png',
            ],
            AIDriven: [
                'https://websiteoss.ecoflow.com/upload/image/1744876771416/Frame%201612689844.png',
                'https://websiteoss.ecoflow.com/upload/image/1744458336586/Frame%201612690124.png',
            ],
            Safety: [
                'https://websiteoss.ecoflow.com/upload/image/1744458249713/Frame%201612689843.png',
                'https://websiteoss.ecoflow.com/upload/image/1744458336985/Frame%201612690126.png',
            ],
            CutCosts: [
                'https://websiteoss.ecoflow.com/upload/image/1744458249883/Frame%201612689844.png',
                'https://websiteoss.ecoflow.com/upload/image/1744458336804/Frame%201612690125.png',
            ],
        },
        nl: {
            page: [
                'https://websiteoss.ecoflow.com/upload/image/1744876856864/Frame%201612689842.png',
                'https://websiteoss.ecoflow.com/upload/image/1744458336412/Frame%201612690123.png',
            ],
            AIDriven: [
                'https://websiteoss.ecoflow.com/upload/image/1744876771416/Frame%201612689844.png',
                'https://websiteoss.ecoflow.com/upload/image/1744458336586/Frame%201612690124.png',
            ],
            Safety: [
                'https://websiteoss.ecoflow.com/upload/image/1744458249713/Frame%201612689843.png',
                'https://websiteoss.ecoflow.com/upload/image/1744458336985/Frame%201612690126.png',
            ],
            CutCosts: [
                'https://websiteoss.ecoflow.com/upload/image/1744458249883/Frame%201612689844.png',
                'https://websiteoss.ecoflow.com/upload/image/1744458336804/Frame%201612690125.png',
            ],
        },
        uk: {
            page: [
                'https://websiteoss.ecoflow.com/upload/image/1744876940118/Frame%201612690142.png',
                'https://websiteoss.ecoflow.com/upload/image/1744458510896/Frame%201612690138.png',
            ],
            AIDriven: [
                'https://websiteoss.ecoflow.com/upload/image/1744876771416/Frame%201612689844.png',
                'https://websiteoss.ecoflow.com/upload/image/1744458511069/Frame%201612690139.png',
            ],
            Safety: [
                'https://websiteoss.ecoflow.com/upload/image/1744458446340/Frame%201612690144.png',
                'https://websiteoss.ecoflow.com/upload/image/1744458511441/Frame%201612690141.png',
            ],
            CutCosts: [
                'https://websiteoss.ecoflow.com/upload/image/1744458446530/Frame%201612690145.png',
                'https://websiteoss.ecoflow.com/upload/image/1744458511253/Frame%201612690140.png',
            ],
        },
        de: {
            page: ['https://websiteoss.ecoflow.com/upload/image/1744877017435/p%20c.png', 'https://websiteoss.ecoflow.com/upload/image/1744619589795/m.png'],
            AIDriven: [
                'https://websiteoss.ecoflow.com/upload/image/1744876771416/Frame%201612689844.png',
                'https://websiteoss.ecoflow.com/upload/image/1744358601417/Frame%201612690052.png',
            ],
            Safety: [
                'https://websiteoss.ecoflow.com/upload/image/1744358529115/Frame%201612689845.png',
                'https://websiteoss.ecoflow.com/upload/image/1744358601647/Frame%201612690028.png',
            ],
            CutCosts: [
                'https://websiteoss.ecoflow.com/upload/image/1744358528905/Frame%201612689846.png',
                'https://websiteoss.ecoflow.com/upload/image/1744358601009/Frame%201612690027.png',
            ],
        },
        fr: {
            page: [
                'https://websiteoss.ecoflow.com/upload/image/1744876171861/fr-pc%20(1).png',
                'https://websiteoss.ecoflow.com/upload/image/1744620190056/m.png',
            ],
            AIDriven: [
                'https://websiteoss.ecoflow.com/upload/image/1744876771416/Frame%201612689844.png',
                'https://websiteoss.ecoflow.com/upload/image/1744457765482/Frame%201612690109.png',
            ],
            Safety: [
                'https://websiteoss.ecoflow.com/upload/image/1744457535474/Frame%201612690114.png',
                'https://websiteoss.ecoflow.com/upload/image/1744457765872/Frame%201612690111.png',
            ],
            CutCosts: [
                'https://websiteoss.ecoflow.com/upload/image/1744457535610/Frame%201612690115.png',
                'https://websiteoss.ecoflow.com/upload/image/1744457765666/Frame%201612690110.png',
            ],
        },
        it: {
            page: [
                'https://websiteoss.ecoflow.com/upload/image/1744876856864/Frame%201612689842.png',
                'https://websiteoss.ecoflow.com/upload/image/1744458336412/Frame%201612690123.png',
            ],
            AIDriven: [
                'https://websiteoss.ecoflow.com/upload/image/1744876771416/Frame%201612689844.png',
                'https://websiteoss.ecoflow.com/upload/image/1744458336586/Frame%201612690124.png',
            ],
            Safety: [
                'https://websiteoss.ecoflow.com/upload/image/1744458249713/Frame%201612689843.png',
                'https://websiteoss.ecoflow.com/upload/image/1744458336985/Frame%201612690126.png',
            ],
            CutCosts: [
                'https://websiteoss.ecoflow.com/upload/image/1744458249883/Frame%201612689844.png',
                'https://websiteoss.ecoflow.com/upload/image/1744458336804/Frame%201612690125.png',
            ],
        },
        es: {
            page: [
                'https://websiteoss.ecoflow.com/upload/image/1744876856864/Frame%201612689842.png',
                'https://websiteoss.ecoflow.com/upload/image/1744458336412/Frame%201612690123.png',
            ],
            AIDriven: [
                'https://websiteoss.ecoflow.com/upload/image/1744876771416/Frame%201612689844.png',
                'https://websiteoss.ecoflow.com/upload/image/1744458336586/Frame%201612690124.png',
            ],
            Safety: [
                'https://websiteoss.ecoflow.com/upload/image/1744458249713/Frame%201612689843.png',
                'https://websiteoss.ecoflow.com/upload/image/1744458336985/Frame%201612690126.png',
            ],
            CutCosts: [
                'https://websiteoss.ecoflow.com/upload/image/1744458249883/Frame%201612689844.png',
                'https://websiteoss.ecoflow.com/upload/image/1744458336804/Frame%201612690125.png',
            ],
        },
    };
    const list = [
        {
            pc: imgItems[locale].page[0],
            h5: imgItems[locale].page[1],
            title: t('card1'),
            href: '#page-oasis-C',
        },
        {
            pc: imgItems[locale].AIDriven[0],
            h5: imgItems[locale].AIDriven[1],
            title: t('card2'),
            href: '#AIDriven',
        },
        {
            pc: imgItems[locale].Safety[0],
            h5: imgItems[locale].Safety[1],
            title: t('card3'),
            href: '#Safety',
        },
        {
            pc: imgItems[locale].CutCosts[0],
            h5: imgItems[locale].CutCosts[1],
            title: t('card4'),
            href: '#CutCosts',
        },
    ];
    const { isH5 } = useMediaDevice();

    useEffect(() => {
        if (isH5) return;
        const show = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const cards = document.querySelectorAll('.listA-card') as unknown as HTMLDivElement[];
                        if (entry.intersectionRatio >= 0.2) {
                            const title = document.querySelector('#ListA .listA-title') as HTMLDivElement;
                            title.classList.add('enter');
                        }

                        if (entry.intersectionRatio >= 0.5) {
                            if (!cards) return;
                            [...cards].map((card, idx) => {
                                setTimeout(() => {
                                    card.classList.add('enter');
                                }, idx * 140);
                            });
                        }
                    }
                });
            },
            {
                threshold: [0.2, 0.5],
            },
        );
        show.observe(document.getElementById('ListA') as HTMLDivElement);
        return () => {
            show.disconnect();
        };
    }, [isH5]);

    return (
        <div className={`page-oasis-B ${styles.TheComp}`} id="ListA">
            <div className="listA-title">{t('title')}</div>
            {isH5 ? (
                <Swiper
                    className="listA-swiper"
                    modules={[Pagination]} // 注册模块
                    pagination={{ clickable: true }} // 启用 Pagination，并允许点击切换
                    slidesPerView={1}
                    spaceBetween={24}
                    loop={true} // 增加无限滑动功能
                >
                    {[list[0], list[1], list[3], list[2]].map((item, idx) => (
                        <SwiperSlide key={idx}>
                            <a className="swiper-card" href={item?.href}>
                                <EfImg className="swiper-card-img" pc={item.pc} h5={item.h5} />
                                <div className="swiper-card-bottom">
                                    <div className="swiper-card-title">{item.title}</div>
                                    <div className="swiper-card-btn">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                                            <path
                                                d="M5.88331 5.98638C5.60582 5.68683 5.15601 5.68683 4.87852 5.98638C4.60104 6.28592 4.60104 6.7716 4.87852 7.07114L8.66798 11.162C8.94304 11.459 9.38816 11.462 9.66659 11.1687L13.4561 7.17736C13.737 6.88152 13.7425 6.3959 13.4684 6.09268C13.1944 5.78946 12.7446 5.78348 12.4637 6.07931L9.17655 9.54153L5.88331 5.98638Z"
                                                fill="#fff"
                                                opacity=".5"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </a>
                        </SwiperSlide>
                    ))}
                </Swiper>
            ) : (
                <div className="listA-cards">
                    {list.map((item, idx) => (
                        <a
                            className="listA-card"
                            href={item.href}
                            key={idx}
                            style={{ gridArea: `a${idx + 1}` }}
                            onClick={() => {
                                gtm.push({
                                    event: 'uaEvent',
                                    event_name: 'click_anchor',
                                    position: item.href,
                                    button_name: item.title,
                                });
                            }}
                        >
                            <EfImg className="listA-card-img" pc={item.pc} />
                            <div className="listA-card-bottom">
                                <div className="listA-card-title">{item.title}</div>
                                <div className="listA-card-btn">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                                        <path
                                            d="M5.88331 5.98638C5.60582 5.68683 5.15601 5.68683 4.87852 5.98638C4.60104 6.28592 4.60104 6.7716 4.87852 7.07114L8.66798 11.162C8.94304 11.459 9.38816 11.462 9.66659 11.1687L13.4561 7.17736C13.737 6.88152 13.7425 6.3959 13.4684 6.09268C13.1944 5.78946 12.7446 5.78348 12.4637 6.07931L9.17655 9.54153L5.88331 5.98638Z"
                                            fill="#fff"
                                            opacity=".5"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </a>
                    ))}
                </div>
            )}
        </div>
    );
}
